import React from 'react';
import ErrorBoundary from './ErrorBoundary';
import './RouteErrorBoundary.css';

const RouteErrorFallback = ({ error, onReset }) => (
  <div className="route-error-container">
    <div className="route-error-content">
      <div className="route-error-icon">
        <svg width="72" height="72" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </div>
      
      <h1 className="route-error-title">Page Error</h1>
      
      <p className="route-error-message">
        Something went wrong while loading this page. This could be due to a temporary issue or a problem with the page content.
      </p>
      
      <div className="route-error-actions">
        <button 
          onClick={() => window.location.href = '/'}
          className="route-error-home-button"
        >
          Go Home
        </button>
        
        <button 
          onClick={() => window.location.reload()}
          className="route-error-refresh-button"
        >
          Refresh Page
        </button>
        
        <button 
          onClick={onReset}
          className="route-error-retry-button"
        >
          Try Again
        </button>
      </div>
    </div>
  </div>
);

const RouteErrorBoundary = ({ children }) => {
  return (
    <ErrorBoundary fallback={RouteErrorFallback}>
      {children}
    </ErrorBoundary>
  );
};

export default RouteErrorBoundary;